import React from 'react';
import { CircularProgress, Grid, Typography, Paper } from '@material-ui/core';
import index from '../data/index';
import NavBar from '../components/navbar';
import OverviewCard from '../components/overviewcard';
import '../styles/search.css';

const loadingClass = "search loading";
const titleClass = "search title";

const similarity = require('string-similarity');

const searchFor = (query) => {
    const result = [];
    Object.keys(index).forEach((kl) => {
        Object.keys(index[kl]).forEach((el) => {
            const element = index[kl][el]
            const titleMatch = similarity.compareTwoStrings(query, element['title']);
            const keywordMatch = similarity.findBestMatch(query, element['keywords']).bestMatch.rating;
            result.push({ sim: Math.max(titleMatch, keywordMatch), klasse: kl, 'element': element, name: el });
        });
    });
    //console.log(similarity.compareTwoStrings('sring1', 'string2'));
    //console.log(similarity.findBestMatch('string1', ['string', 'int', 'short', 'long', 'char']));
    return result.sort((a, b) => {
        return b['sim'] - a['sim'];
    });
}

const color = (sim) => {
    sim = Math.max(0, Math.min(1, sim));
    const g = sim * 127 + 127;
    const r = (1 - sim) * 127 + 127;
    return { 'r': r, 'g': g };
}

class Search extends React.Component {

    constructor(...args) {
        super(...args);
        this.state = {
            results: [],
            finished: false,
        }
        this.loadResults = this.loadResults.bind(this);
    }

    componentDidMount() {
        this.loadResults();
    }
    
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.for !== this.props.for) {
            this.loadResults();
        }
    }


    async loadResults() {
        let needle = this.props.for;
        if (needle === undefined || needle === null)
            needle = "";
        await this.setState({
            results: searchFor(needle),
            finished: true,
        });
    }

    render() {
        if (!this.state.finished) {
            return (
                <>
                    <NavBar />
                    <CircularProgress className={loadingClass} />
                </>
            );
        }
        return (
            <>
                <NavBar />
                <Paper>
                    <Typography variant="h2" className={titleClass}>Ergebnisse für: {this.props.for}</Typography>
                </Paper>
                <Grid
                    container
                    justify="center"
                    alignItems="center"
                >
                    {
                        this.state.results.map((result) => {
                            const element = result['element'];
                            const col = color(result['sim']);
                            let buttons = [];
                            Object.keys(element['types']).forEach((type) => {
                                buttons.push({ 'name': type, 'href': '/klasse/' + result['klasse'] + '/theme/' + result['name'] + '/type/' + type });
                            });
                            return (
                                <Grid container item key={element['title'] + '-' + element['description']}>
                                    <OverviewCard title={element['title']} description={element['description']} buttons={buttons} colora={'linear-gradient(rgba(0, 0, 0, 0) 15%, rgba(' + col.r + ', ' + col.g + ', 127, 0.1) 50%, rgba(0, 0, 0, 0) 85%)'} />
                                </Grid>
                            );
                        })}
                </Grid>
            </>
        )
    }

}

export default Search;